interface FetchApiOptions {
  method: string;
  url: string;
  data?: unknown;
  params?: Record<string, string | number | boolean | undefined>;
  signal?: AbortSignal;
}

export class FetchApiError extends Error {
  response: { status: number; data: unknown };

  constructor(status: number, data: unknown) {
    super(`Request failed with status ${status}`);
    this.name = "FetchApiError";
    this.response = { status, data };
  }
}

export async function fetchApi({ method, url, data, params, signal }: FetchApiOptions): Promise<{ data: any }> {
  let fullUrl = url;
  if (params) {
    const entries = Object.entries(params)
      .filter(([, v]) => v !== undefined)
      .map(([k, v]) => [k, String(v)] as [string, string]);
    if (entries.length) {
      const separator = fullUrl.includes("?") ? "&" : "?";
      fullUrl += separator + new URLSearchParams(entries).toString();
    }
  }

  const options: RequestInit = { method: method.toUpperCase() };

  if (signal) {
    options.signal = signal;
  }

  if (data !== undefined) {
    options.headers = { "Content-Type": "application/json" };
    options.body = JSON.stringify(data);
  }

  const response = await fetch(fullUrl, options);

  let responseData: unknown;
  try {
    responseData = await response.json();
  } catch {
    responseData = undefined;
  }

  if (!response.ok) {
    throw new FetchApiError(response.status, responseData);
  }

  return { data: responseData };
}
